export default __webpack_public_path__ + "static/media/slider-img13.ca1d60f5.jpg";